import { ReactComponent as ReactIconPart } from "../../../assets/images/part.svg";
import { ReactComponent as ReactIconChange } from "../../../assets/images/change.svg";
import { ReactComponent as ReactIconPrint } from "../../../assets/images/print.svg";
import { ReactComponent as ReactIconHelpBoard } from "../../../assets/images/help-board.svg";
import { ReactComponent as ReactIconChecklists } from "../../../assets/images/checklist-icon.svg";
import { ReactComponent as ReactIconWorkstation } from "../../../assets/images/workstation.svg";

const optionsSideBar = t => [
  {
    key: "dashboard",
    label: "workstation",
    icon: <ReactIconWorkstation />
  },
  {
    key: "workstations",
    label: "changeWorkstation",
    icon: <ReactIconChange />
  },
  {
    key: "select-parts",
    label: "changePartOrManufacturingOrder",
    icon: <ReactIconPart strokeWidth="2px" />
  },
  {
    key: "checklists",
    label: t("checklists"),
    icon: (
      <ReactIconChecklists
        stroke="#7d80da"
        height="1.7rem"
        width="2rem"
        strokeWidth="2px"
      />
    )
  },
  {
    key: "menu-print-tags",
    label: "traceability",
    icon: <ReactIconPrint />
  },
  {
    key: "help-board",
    label: "helpBoard",
    icon: <ReactIconHelpBoard />
  }
];

export default optionsSideBar;
